import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import OptCreditBuilder from "./credit-builder";
import { useConsumerDealsData } from "../../Pages/Deals";

import renderCreditBuilderTracker from "../../Organisms/Modals/Credit-Builder/credit-builder-tracker";

import { useModalContext } from "../../Contexts/ModalContext";

import { useCreditReportDetails } from "../../CustomHooks/Queries";

import { monthNames } from "../../Utils/constants";

import { ArrowLeftCircle, HourGlassOutlinedThin, Surge } from "../../Assets/Icons";

import "./credit-builder.scss";
import "./credit-builder-responsive.scss";

export default function CreditBuilderSettings() {
  const navigate = useNavigate();

  return (
    <section className="card-section-wrapper">
      <div className="max-width-container">
        <div className="card-section">
          <div className="section-header">
            <button className="go-back-button" onClick={() => navigate(-1)} aria-label="Go back">
              <ArrowLeftCircle />
            </button>
            <h3 className="section-title">Settings</h3>
            <div className="dummy"></div>
          </div>
          <CreditBuilder />
        </div>
      </div>
    </section>
  );
}

export const CreditBuilder = () => {
  const modalContext = useModalContext();

  const { isLoading: isLoadingCreditReporting, data: creditReporting } = useCreditReportDetails();
  const { isLoadingConsumerDealsData, stakeSaverOffer } = useConsumerDealsData();

  const isCreditReportingOptedIn = useMemo(() => {
    return creditReporting?.data?.data.credit_builder?.opted_in;
  }, [creditReporting?.data?.data.credit_builder?.opted_in]);

  const creditBuilderTrackerList = useMemo(() => {
    return creditReporting?.data?.data.credit_builder_tracker;
  }, [creditReporting?.data?.data.credit_builder_tracker]);

  const hasInactiveStakeSaverOffer = !!stakeSaverOffer && !stakeSaverOffer?.is_activated;

  const isLoading = isLoadingCreditReporting || isLoadingConsumerDealsData;

  const CreditBuilderEmptyStateIcon = isCreditReportingOptedIn ? HourGlassOutlinedThin : Surge;

  return isLoading ? (
    <div className="loading-content">
      <CircularProgress />
    </div>
  ) : (
    <div className="credit-builder">
      <OptCreditBuilder hasInactiveStakeSaverOffer={hasInactiveStakeSaverOffer} optedIn={isCreditReportingOptedIn} />
      <div className="credit-builder-tracker mt-sm-6 mt-4">
        <div className="section-header">
          <h3 className="section-title">Credit Builder Tracker</h3>
          {creditBuilderTrackerList.length > 10 && (
            <button className="see-all-button" onClick={renderCreditBuilderTracker.bind(this, modalContext)}>
              View All
            </button>
          )}
        </div>
        {creditBuilderTrackerList.length > 0 ? (
          <>
            {creditBuilderTrackerList.slice(0, 7).map((payment, idx) => {
              const isReported = payment?.is_reported;
              return (
                <div key={idx} className="credit-builder-item">
                  <h5 className="text-lg-medium color--mist mb-3">
                    {`${monthNames[parseInt(payment.month) - 1] || ""} ${payment.year}`}
                  </h5>
                  <p className="text-base-regular color--mist mb-0">
                    {isReported ?? false ? "✅" : "⏸️"} {payment?.description}
                  </p>
                </div>
              );
            })}
          </>
        ) : (
          <div className="no-records mt-6">
            <CreditBuilderEmptyStateIcon className="icon" />
            {hasInactiveStakeSaverOffer
              ? "Join Stake Saver to start reporting your rent payments."
              : isCreditReportingOptedIn
              ? "Your first Credit Builder report will appear here soon."
              : "Opt In to Credit Builder to start reporting your rent payments."}
          </div>
        )}
      </div>
    </div>
  );
};
